export async function readApiKey() {
  return await localStorage.getItem("apiKey");
}

export async function readApiKeyDate() {
  return await localStorage.getItem("apiKeyExpireAt");
}

export async function storeApiKey(token, tokenDate) {
  console.log("func helper session storeApiKey");
  try {
    await localStorage.setItem("apiKey", token);
    await localStorage.setItem("apiKeyExpireAt", tokenDate);

    return true;
  } catch (error) {
    // Error saving data
  }
  return false;
}

export async function deleteApiKey() {
  console.log("func helper session deleteApiKey");
  await localStorage.removeItem("apiKey");
  await localStorage.removeItem("apiKeyExpireAt");

  return true;
}

// Helper to get cookie value by name
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export async function readUserId() {
  return getAuthCookie("sidedCurrentUserId");
}

export async function readUserToken() {
  return getAuthCookie("sidedAccessToken");
}

export async function readUserTokenDate() {
  return getAuthCookie("sidedAccessTokenExpireAt");
}

export async function readUserRefreshToken() {
  return getAuthCookie("sidedAccessRefreshToken");
}

export async function readUserRefreshTokenDate() {
  return getAuthCookie("sidedAccessRefreshTokenExpireAt");
}


export async function storeUserId(
  id,
  token,
  tokenDate,
  refreshToken,
  refreshTokenDate,
) {
  try {
    setAuthCookie("sidedCurrentUserId", id);
    setAuthCookie("sidedAccessToken", token);
    setAuthCookie("sidedAccessTokenExpireAt", tokenDate);
    setAuthCookie("sidedAccessRefreshToken", refreshToken);
    setAuthCookie("sidedAccessRefreshTokenExpireAt", refreshTokenDate);
    return true;
  } catch (error) {
    // Error saving data
  }
  return false;
}

export async function deleteUserId() {
  removeAuthCookie("sidedCurrentUserId");
  removeAuthCookie("sidedAccessToken");
  removeAuthCookie("sidedAccessTokenExpireAt");
  removeAuthCookie("sidedAccessRefreshToken");
  removeAuthCookie("sidedAccessRefreshTokenExpireAt");
  return true;
}
// Helper to get the correct cookie domain
export const getCookieDomain = () => {
  const { hostname } = window.location;
  if (hostname.indexOf("sided.co") !== -1) {
    return "sided.co";
  }
  if (hostname.indexOf("sided.dev") !== -1) {
    return "sided.dev";
  }
  if (hostname.indexOf("sidedstage.com") !== -1) {
    return "sidedstage.com";
  }
  return hostname;
};

// Session.ts - Helper for auth cookies (cross-domain)


export const setAuthCookie = (name, value) => {
  const domain = getCookieDomain();
  document.cookie = `${name}=${value}; path=/; domain=.${domain}`;
}


export const removeAuthCookie = (name) => {
  const domain = getCookieDomain();
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`;
}

export const getAuthCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const part = parts.pop();
    if (part) return part.split(';').shift() || null;
  }
  return null;
}

